import React from 'react';

import './ButtonSpinner.css';

const buttonSpinner = () => (
    <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
);

export default buttonSpinner;
